export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const options = {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  };
  return date.toLocaleDateString("en-US", options);
};

export const formatDatev2 = (dateInput) => {
  const dateObj = new Date(dateInput); // ensure it's a Date object

  if (isNaN(dateObj)) return "Invalid Date";

  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();

  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
};

export const convertADtoBS = (adDate) => {
  const bsDateObj = bs.toBik(new Date(adDate));
  const { year, month, day } = bsDateObj;

  const bsDate = `${String(day).padStart(2, "0")}/${String(month).padStart(
    2,
    "0"
  )}/${year}`;

  let hours = adDate.getHours();
  const minutes = String(adDate.getMinutes()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;

  const time = `${hours}:${minutes} ${ampm}`;

  return `${bsDate} ${time}`;
};

export const formatDateTime = (dateString) => {
  const date = new Date(`${dateString}`);
  if (isNaN(date.getTime())) {
    return "Invalid Date";
  }

  const dateOptions = {
    day: "numeric",
    month: "long",
    year: "numeric",
  };

  const weekdayOptions = {
    weekday: "long",
  };
  const timeOptions = {
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };

  const formattedDate = date.toLocaleDateString("en-AU", dateOptions);
  const formattedWeekday = date.toLocaleDateString("en-AU", weekdayOptions);
  const formattedTime = date.toLocaleTimeString("en-AU", timeOptions);

  return `${formattedTime}, ${formattedWeekday}, ${formattedDate}`;
};
